export default "__VITE_ASSET__Co5I1Cs1__"